export const CONTAINER_W = ["100%", "100%", "100%", "960px", "960px"];
export const MODAL_W = ["400px", "480px", "480px", "480px", "480px"]

// maxW={[200, 400, 600, 800, 1120]}
